import { render } from "./AddModelDialog.vue?vue&type=template&id=2640ae8d&ts=true"
import script from "./AddModelDialog.vue?vue&type=script&lang=ts"
export * from "./AddModelDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__